import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

interface BoardingQrCodeProps {
  token: string;
  label?: string;
  size?: number;
  className?: string;
  showToken?: boolean;
}

/** Short code display + QR (scanner accepts raw token). */
const BoardingQrCode: React.FC<BoardingQrCodeProps> = ({
  token,
  label,
  size = 128,
  className = '',
  showToken = true,
}) => {
  const [dataUrl, setDataUrl] = useState<string>('');
  const [copied, setCopied] = useState(false);

          const displayCode = token.includes('-') && token.length > 12
    ? token
    : token.replace(/[\s\-]/g, '').toUpperCase();

  const isShortCode = !displayCode.includes('-') && displayCode.length <= 8;

  useEffect(() => {
    let cancelled = false;
    if (!token) {
      setDataUrl('');
      return;
    }
    QRCode.toDataURL(displayCode, {
      width: size,
      margin: 1,
      errorCorrectionLevel: 'M',
    })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch(() => {
        if (!cancelled) setDataUrl('');
      });
    return () => {
      cancelled = true;
    };
  }, [token, displayCode, size]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(displayCode);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt('انسخ رمز الصعود:', displayCode);
    }
  };

  if (!token) return null;

  return (
    <div className={`flex flex-col items-center gap-2 ${className}`}>
      {label && (
        <p className="text-sm font-medium text-gray-800 text-center leading-snug">{label}</p>
      )}

      {showToken && (
        <div className="w-full text-center">
          <p className="text-[11px] text-gray-500 mb-1">رمز الصعود</p>
          <p
            className={`font-bold tracking-[0.2em] text-gray-900 select-all ${
              isShortCode ? 'text-2xl sm:text-3xl' : 'text-xs break-all tracking-normal'
            }`}
            dir="ltr"
          >
            {displayCode}
          </p>
        </div>
      )}

      {dataUrl ? (
        <img
          src={dataUrl}
          alt={label || 'رمز الصعود'}
          width={size}
          height={size}
          className="rounded-lg border border-gray-200 bg-white p-1.5"
        />
      ) : (
        <div
          className="flex items-center justify-center bg-gray-100 text-gray-400 text-xs rounded-lg"
          style={{ width: size, height: size }}
        >
          جاري التحميل…
        </div>
      )}

      {showToken && (
        <button
          type="button"
          onClick={handleCopy}
          className="text-xs px-3 py-1.5 rounded-lg bg-gray-900 text-white hover:bg-gray-800"
        >
          {copied ? 'تم النسخ ✓' : 'نسخ الرمز'}
        </button>
      )}
    </div>
  );
};

export default BoardingQrCode;
